import { useState, useEffect } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import {Theme} from "../../lib/theme"

export type Slide = {
  imageUrl: string;
  dotPosition: {
    top: string;
    left: string;
  };
  caption?: string;
  show?: boolean;
};

type YouTubeSliderProps = {
  slides: Slide[];
  bgColor: string;
};

export default function ImageSlider({ slides, bgColor }: YouTubeSliderProps) {
  const [currentIndex, setCurrentIndex] = useState(0);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentIndex((prev) => (prev + 1) % slides.length);
  //   }, 4000);

  //   return () => clearInterval(interval);
  // }, [slides.length]);
  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const current = slides[currentIndex];

  return (
    <div
      className={`rounded-lg shadow-lg overflow-hidden border border-blue-200 ${bgColor} text-white space-y-6 flex flex-col w-full h-full`}
    >
      <div className="relative aspect-auto rounded-lg overflow-hidden w-full h-full">
        <img
          src={current.imageUrl}
          alt="Slide"
          className="w-full h-full object-cover"
        />

        {current.show !== false && (
          <div
            className="absolute w-3.5 h-3.5 bg-purple-600 rounded-full animate-ping"
            style={{
              top: current.dotPosition.top,
              left: current.dotPosition.left,
            }}
            title="Click here"
          />
        )}
        
        <button
          title="prevSlide"
          onClick={prevSlide}
          className="absolute top-1/2 left-2 transform -translate-y-1/2 bg-white  p-2 rounded-full shadow hover:bg-gray-100 z-10"
          style={{
            color:Theme.colors.primary
          }}
        >
          <FaChevronLeft />
        </button>
        <button
          title="nextSlide"
          onClick={nextSlide}
          className="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white  p-2 rounded-full shadow hover:bg-gray-100 z-10"
        style={{
            color:Theme.colors.primary
          }}
       >
          <FaChevronRight />
        </button>
      </div>
    </div>
  );
}
